/*
  Страница находок радара с сервера (21.10.2026, требование владельца: «пагинация должна
  быть серверной, а не на фронте»).

  Раньше `GET /radar` отдавал ВСЕ находки, а страница сама отбирала «горит» и «возможность»
  и резала страницы в браузере. Теперь сервер отбирает по срочности ДО среза и отдаёт одну
  страницу вместе с общим числом; вместе со страницей приходит сводка (плитки, числа
  переключателя, перечень «чего радар не видит»), её страница получает через `onReport`.

  Компонент создаётся заново при смене срочности (`key` на странице): это другой список, и
  читать его начинают с первой страницы, а не с той, на которой остановились в прошлом.
*/

import { useCallback } from 'react'

import { api } from '../api/client.js'
import { Loading, Notice } from './Common.jsx'
import RadarTable from './RadarTable.jsx'
import usePagedList from './usePagedList.js'

const ALL = 'all'

export default function RadarFindings({ urgency, onReport }) {
  const load = useCallback(
    (window) =>
      api
        .radar({ ...window, urgency: urgency === ALL ? undefined : urgency })
        .then((report) => ({ items: report.findings.items, total: report.findings.total, report })),
    [urgency],
  )
  /* Сводка уходит наверх только из ПРИНЯТОГО ответа и в момент его принятия (23.10.2026) -
     так же, как у исполнения: сводка радара от страницы не зависит, и вреда от устаревшего
     ответа здесь не было, но правило одно на оба экрана, чтобы следующий список не скопировал
     опасный вариант. `onAccepted`, а не эффект: переключатель «Горит N» появляется в той же
     отрисовке, что и строки (`usePagedList.js`). */
  const accept = useCallback((answer) => onReport(answer.report), [onReport])
  const { rows, error, bar } = usePagedList(load, undefined, 0, null, accept)

  if (error) return <Notice error={error} />
  if (rows === null) return <Loading what="Просматриваем портфель" />
  if (rows.length === 0) {
    return (
      <div className="muted">
        {urgency === 'burning'
          ? 'Ничего не горит - это нормальное состояние портфеля, а не ошибка.'
          : 'Неиспользованных возможностей нет.'}
      </div>
    )
  }
  return <RadarTable rows={rows} bar={bar} />
}
